import { Component, h, Listen, Method, Prop, State, Host, Event, EventEmitter } from '@stencil/core';

import axios from '../../../utils/get-axios';
import { JSX } from '@stencil/core/internal';

const ACC = (window as any).ACC;
@Component({
  tag: 'lilu-modal',
  styleUrl: 'lilu-modal.scss',
  shadow: true,
})
export class LiluModal {
  @Prop() appearance = '';
  @Prop() showButton = true;
  @Prop() modalType: string;
  @Prop() dataModalId: string;
  @Prop() CSRFToken?: any;
  @Prop() isLoading = false;
  @Prop() isClosable = true;
  @Prop() isLogin = false;
  @Prop() openOnLoad: string = null;
  @Prop() closeBtn: string = 'default';

  @Event() gotClosed: EventEmitter<boolean>;
  @State() isModalOpen = false;

  componentWillLoad() {
    if (this.openOnLoad) {
      this.isModalOpen = true;
    }
  }

  componentDidLoad() {
    if (ACC !== undefined) {
      this.CSRFToken = ACC.config.CSRFToken;
    }
  }

  @Listen('modalIsLoading')
  handleModalIsLoading(e: CustomEvent) {
    this.isLoading = e.detail.isLoading;
  }

  @Listen('closeModal')
  async handlingCloseModal() {
    this.handleModal(false);
  }

  @Method()
  async open(productId = '', isClosable = true, isLogin = false) {
    this.isLogin = isLogin;
    this.isClosable = isClosable;
    this.handleModal(true);
    document.querySelector('lilu-modal').setAttribute('data-product-id', productId);
  }

  @Method()
  async close() {
    this.gotClosed.emit();
    this.handleModal(false);
  }

  @Listen('click')
  handleClick(e) {
    const element = e.target as HTMLElement;

    if (element.closest('.button')) {
      const hasAttr = element.closest('.button').querySelector('[modal-content]');

      if (hasAttr !== null) {
        const url = hasAttr.getAttribute('modal-content');
        this.getContent(element, url);
      }
    }
  }

  @Listen('keydown', { target: 'document' })
  eventKeyEscape(e) {
    let keyCode = e.key;

    if (keyCode === 'Escape') {
      this.handleModal(false);
    }
  }

  getContent(element, url) {
    axios
      .post(url, '', {
        headers: {
          CSRFToken: ACC.config.CSRFToken,
        },
      })
      .then(function (response) {
        this.isLogin = response.data.content.indexOf('lilu-login') >= 0;
        element.closest('lilu-modal').querySelector('.content').innerHTML = response.data.content;
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  handleModal(isOpen: boolean) {
    if ((!isOpen && this.isClosable) || isOpen) {
      this.isModalOpen = isOpen;
      document.querySelector('body').classList.toggle('overflow', this.isModalOpen);

      if (!this.isModalOpen) {
        this.gotClosed.emit();
      }
    }
  }

  renderSVGCloseBtn(): JSX.Element {
    return (
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.05383 13.3077L0 12.2538L5.6 6.65383L0 1.05383L1.05383 0L6.65383 5.6L12.2538 0L13.3077 1.05383L7.70765 6.65383L13.3077 12.2538L12.2538 13.3077L6.65383 7.70765L1.05383 13.3077Z"
          fill="#1C1B1F"
        />
      </svg>
    );
  }

  render() {
    return (
      <Host>
        <div>
          <div class={`modal ${this.isModalOpen ? 'open' : ''} ${this.appearance} ${this.isLogin ? 'login-modal' : ''}`}>
            <div class={`modal-overlay`} onClick={() => this.handleModal(false)} />
            <div class={`modal-content`}>
              <div class={`modal-header close-btn-svg`}>
                <span>
                  <slot name="modal-back"></slot>
                </span>
                {this.isClosable ? (
                  <button class="close" onClick={() => this.handleModal(false)}>
                    {this.renderSVGCloseBtn()}
                  </button>
                ) : (
                  ''
                )}
              </div>

              <div class={`modal-body`}>
                <slot></slot>
                {this.isLoading ? (
                  <div class={'isLoading'}>
                    <div class={'spinner'}></div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <div class={`button ${this.isModalOpen ? 'hide' : ''}`} onClick={() => this.handleModal(true)}>
            <slot name="button"></slot>
          </div>
        </div>
      </Host>
    );
  }
}
